import { api } from 'app/utils/api/helpers'

export const searchTeamContacts = (teamId, searchText, from = 0, size = 20) => {
  return api.get(
    `sm/teams/${teamId}/contacts/search?q=${searchText}&from=${from}&size=${size}`,
  )
}

export const searchTeamContactsEmail = (teamId, searchText) => {
  return api.get(`sm/teams/${teamId}/contacts/searchemail?q=${searchText}`)
}

export const searchTeamContactsMobile = (teamId, searchText) => {
  return api.get(`sm/teams/${teamId}/contacts/searchmobile?q=${searchText}`)
}
